export default __webpack_public_path__ + "static/media/High Priest's Ring of Strength.24228c99.jpg";